export { PageFooter } from './PageFooter';
